var SdsAccordionContext = Symbol('@superbet-group/SdsAccordionContext');

export { SdsAccordionContext };
